import React, { useState, useCallback, useEffect } from 'react';
import useApi from '../../api/useApi';
import '../../scrollbar.css';
import moment from 'moment';

function index({ zoneData, handleClose, type, hasFloorMap }) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const [stats, setStats] = useState([]);
  const formModel = {
    q: '',
  };
  const [formData, setFormData] = useState(formModel);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const [gateways, getwaysData] = useApi();
  const [gateway, setGateways] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const gatewayURL = `/zone/${zoneData.id}/data?type=${type}`;
    user && getwaysData(gatewayURL, 'GET');
  }, [zoneData]);

  useEffect(() => {
    if (gateways.isError) {
      setGateways([]);
    }
    console.log('loading gateway data', gateways);
    if (!gateways.isLoading && !gateways.isError && gateways.data) {
      setGateways(gateways.data);
      setStats(gateways.data);
      if (gateways.data.zoneData) setFilteredData(gateways.data.zoneData);
    }
    // else {
    //   console.log('here');
    //   const gateData =
    //     zoneData &&
    //     zoneData.GatewayInfos &&
    //     zoneData.GatewayInfos.map((x) => {
    //       return {
    //         blegwId: x.deviceId,
    //         data: [],
    //       };
    //     });
    //   setGateways(gateData);
    // }
  }, [gateways.isLoading, gateways.isError, gateways.data]);

  useEffect(() => {
    if (gateways.data && gateways.data.zoneData) {
      let z = gateways.data.zoneData;
      if (formData.q) {
        z = z.filter(
          (x) =>
            x?.deviceId?.toLowerCase().includes(formData.q.toLowerCase()) ||
            x?.assetName?.toLowerCase().includes(formData.q.toLowerCase()) ||
            x?.tagId?.toLowerCase().includes(formData.q.toLowerCase())
        );

        setFilteredData(z);
      } else {
        setFilteredData(gateways.data.zoneData);
      }
    }
  }, [stats, formData]);

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    return moment(_timestamp).fromNow();
  };

  const getDiff = (ts) => {
    return new Date().getTime() - new Date(ts * 1000).getTime() >= 3600000;
  };

  const downloadReport = () => {
    const rows = [];
    const headerRows = ['ZONE', 'ASSET', 'DEVICE', 'GATEWAY', 'SENSOR VALUES', 'LAST_REPORTED'];
    rows.push(headerRows);
    // iterate through rows of table
    for (let i = 0, row; (row = filteredData[i]); i++) {
      // rows would be accessed using the "row" variable assigned in the for loop
      // Get each cell value/column from the row
      const column0 = zoneData?.name;
      const column1 = type === 'MERAKI' || type === 'Tag-N-Trac' ? row?.assetName : row?.assetName || '';
      const column2 = type === 'MERAKI' || type === 'Tag-N-Trac' ? row?.deviceId : row?.tagId || row?.deviceId;
      const column3 = type === 'MERAKI' || type === 'Tag-N-Trac' ? row?.blegwId : '';
      const column4 =
        type === 'MERAKI' || type === 'Tag-N-Trac' ? row.tm !== null && `${parseFloat(row?.tm).toFixed(2)} ℃` : '';
      const column5 =
        type === 'MERAKI' || type === 'Tag-N-Trac'
          ? row.ts !== null
            ? getTimeoffset(row.ts)
            : 'N/A'
          : getTimeoffset(row.recentTimestamp);

      /* add a new records in the array */
      rows.push([column0, column1, column2, column3, column4, column5]);
    }
    let csvContent = 'data:text/csv;charset=utf-8,';

    /* add the column delimiter as comma(,) and each row splitted by new line character (\n) */
    rows.forEach(function (rowArray) {
      const row = rowArray.join(',');
      csvContent += `${row}\r\n`;
    });
    /* create a hidden <a> DOM node and set its download attribute */
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'zone.csv');
    document.body.appendChild(link);
    /* download the data file  */
    link.click();
  };

  return (
    <div className="z-20 zone_width">
      <div className="block lg:flex mt-1 lg:mt-0 absolute h-8 right-0 -top-10">
        <button
          className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 h-8 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center bg-btnBg text-white button_mobile2 "
          onClick={downloadReport}
        >
          Report
          <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
        </button>
        {hasFloorMap && (
          <button
            className="mt-1 show_map lg:mt-0 w-28 lg:w-max border px-3 py-1  text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-8 bg-btnBg text-white rounded-md"
            onClick={handleClose}
          >
            Show Floor Map
          </button>
        )}
        <div className="mt-1 lg:mt-0 w-full lg:w-max border bg-transparent px-4 py-1.5 rounded-3xl ml-3 flex justify-between items-center right-44 search_zone bg-white">
          <input
            type="text"
            placeholder="Search Asset/Device"
            autoComplete="off"
            className="text-textBox text-xs bg-transparent focus:outline-none"
            value={formData.q}
            name="q"
            onChange={handleInputChange}
            style={{ borderColor: '#e6e6e6' }}
          />
          <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
        </div>
      </div>
      <div className="w-full block zone_hide mb-10">
        <div className="bg-white zone_div1 ">
          <p className="text-md font-bold py-3 w-11/12 m-auto zone_div bg-white ">Gateway(s) in {zoneData.name}</p>
          <div className="w-11/12 m-auto flex text-white zone_div bg-primary">
            <div className="px-6 flex w-full py-3">
              <div className="text-left text-xs w-2/4 ">GATEWAY</div>
              <div className="text-left text-xs w-1/4 flex">
                {' '}
                <img src="assets/img/Antenna.png" className="w-4 mr-1" alt="" />
                RSSI
              </div>
              <div className="text-left text-xs w-1/4 flex">
                {' '}
                <img src="assets/img/Battery.png" className="w-4 mr-1 transform -rotate-90" alt="" />
                BATTERY
              </div>
              <div className="text-left text-xs w-1/4">STATUS</div>
            </div>
          </div>
          {!gateways.isLoading ? (
            <div className="hideScroll pb-1 w-11/12 m-auto bg-white" style={{ overflowY: 'scroll', height: '21vh' }}>
              {gateway.gateways && gateway.gateways.length > 0 ? (
                gateway.gateways.map((item) => {
                  // let bat = <img src="assets/img/Battery.png" className="w-4 mr-2 transform -rotate-90" alt="" />;
                  // let rssi = <img src="assets/img/Antenna.png" className="w-4 mr-2" alt="" />;
                  return (
                    <div
                      className="my-2 px-6 flex py-2.5 text-role font-medium
                        relative"
                      style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    >
                      <div className="flex text-xs w-2/4">{item}</div>
                      <div className="flex text-xs w-1/4">
                        {gateway.shadows && gateway.shadows[item]?.rssi ? `${gateway.shadows[item]?.rssi} dBm` : ''}
                      </div>
                      <div className="flex text-xs w-1/4 pl-1">
                        {gateway.shadows && gateway.shadows[item]?.vbat
                          ? gateway.shadows[item]?.vbat > 100
                            ? `${gateway?.shadows[item]?.vbat} mV`
                            : `${gateway?.shadows[item]?.vbat} %`
                          : ''}
                      </div>
                      <div className="flex text-xs w-1/4">
                        {gateway.shadows && gateway.shadows[item]?.ts ? (
                          getDiff(gateway.shadows[item]?.ts) ? (
                            <p style={{ color: 'red' }}>Offline</p>
                          ) : (
                            <p style={{ color: 'green' }}>Online</p>
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center mt-16">No gateway available</div>
              )}
            </div>
          ) : (
            <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
          )}
        </div>
      </div>
      <div className="w-full block zone_hide ">
        <div
          className="bg-white w-auto w-4 max-w-screen-xl mx-auto"
          style={{
            // boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
            // borderRadius: '6px',
            // height: '40vh',
            overflow: 'auto',
          }}
        >
          <div className="w-full absolute bg-white">
            <p className="text-md font-bold py-3 w-11/12 m-auto zone_div2 bg-white">
              Last reported devices in {zoneData.name}
            </p>
            <div className="bg-primary w-11/12 m-auto flex text-white zone_div2">
              <div className="px-6 flex w-full py-3">
                <div className="text-left text-xs w-2/12">ASSET</div>
                <div className="text-left text-xs w-2/12">DEVICE</div>
                <div className="text-left text-xs w-2/12">GATEWAY</div>
                <div className="text-left text-xs w-2/12">SENSOR VALUES</div>
                <div className="text-left text-xs w-2/12">RSSI</div>
                <div className="text-left text-xs w-2/12">LAST REPORTED</div>
              </div>
            </div>
            {!gateways.isLoading ? (
              <div className="pb-1 hideScroll w-11/12 m-auto zone_div2" style={{ overflow: 'auto', height: '28vh' }}>
                {filteredData.length > 0 ? (
                  filteredData.map((itm) => (
                    <div
                      className="my-2 px-6 flex py-2.5 text-role font-medium
                          relative"
                      style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    >
                      <div className=" flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                        {type === 'MERAKI' || type === 'Tag-N-Trac' ? itm?.assetName : itm?.assetName || ''}
                      </div>
                      <div className=" flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                        {type === 'MERAKI' || type === 'Tag-N-Trac' ? itm?.deviceId : itm?.tagId || itm?.deviceId}
                      </div>
                      <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                        {type === 'MERAKI' || type === 'Tag-N-Trac' ? itm?.blegwId : ''}
                      </div>
                      <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                        {type === 'MERAKI' || type === 'Tag-N-Trac'
                          ? itm.ts !== null && <img src="assets/img/temperature.png" className="w-2 mt-1 mr-2" alt="" />
                          : ''}
                        {type === 'MERAKI' || type === 'Tag-N-Trac'
                          ? itm.tm !== null && `${parseFloat(itm?.tm).toFixed(2)} ℃`
                          : ''}
                      </div>
                      <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                        {type === 'MIST' ? '' : `${itm?.rssi} dBm`}
                      </div>
                      <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                        {type === 'MERAKI' || type === 'Tag-N-Trac'
                          ? itm.ts !== null
                            ? getTimeoffset(itm.ts)
                            : 'N/A'
                          : type === 'MIST'
                          ? getTimeoffset(itm.time)
                          : getTimeoffset(itm.recentTimestamp)}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center mt-16"> No last reported device available</div>
                )}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
